exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notificationwell-cssmodule-notificationwell-component-2vPQ2{border:none}.notificationwell-cssmodule-error-3rQ4a{color:#a94442;background-color:#f2dede}.notificationwell-cssmodule-notificationwell-component-2vPQ2{margin-left:0;margin-right:0}", ""]);

// exports
exports.locals = {
	"notificationwell-component": "notificationwell-cssmodule-notificationwell-component-2vPQ2",
	"error": "notificationwell-cssmodule-error-3rQ4a"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/Home/notificationwell.cssmodule.scss
// module id = 603
// module chunks = 0